/* Pastilla "1 di N" en el carrusel de fotos de la ficha (solo móvil/tablet; en escritorio la oculta el CSS). Pedido Igor 24-oct. */
(function () {
  function init() {
    var g = document.querySelector('mf-product-information .mf-gallery');
    if (!g || g.dataset.mfCounter) return;
    if (g.querySelectorAll('.mf-media').length < 2) return;
    g.dataset.mfCounter = '1';
    var wrap = g.closest('.mf-gallery-wrap') || g.parentElement;
    var pill = document.createElement('div');
    pill.className = 'mf-counter';
    pill.setAttribute('aria-hidden', 'true');
    wrap.appendChild(pill);
    function update() {
      var items = Array.prototype.filter.call(g.querySelectorAll('.mf-media'), function (e) { return e.offsetWidth > 0; });
      var w = g.clientWidth || 1;
      var i = Math.round(g.scrollLeft / w) + 1;
      i = Math.max(1, Math.min(items.length || 1, i));
      pill.textContent = i + ' di ' + (items.length || 1);
      pill.style.display = items.length < 2 ? 'none' : '';
    }
    g.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();